import { Navigate, Route, Routes, useParams } from "react-router-dom";

import RoleBasedRouter from "~/components/RoleBasedRouter";
import { usePostHogPageTracking } from "~/hooks/usePostHogPageTracking";
import ConfigPayments from "~/pages/ConfigPayments";
import Login from "~/pages/Login";
import NotFound from "~/pages/NotFound";
import ResetPassword from "~/pages/ResetPassword";

interface AppRoutesProps {
  isAuthenticated: boolean;
}

// Legacy AP supplier-detail URL → new Contabilidad location, preserving the id.
const LegacySupplierDetailRedirect = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/contabilidad/proveedores/${id}`} replace />;
};

export const AppRoutes = ({ isAuthenticated }: AppRoutesProps) => {
  // Track page views automatically
  usePostHogPageTracking();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/clients"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/clients" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/clients/:clientId"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/clients/:clientId" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/client-approvals"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/client-approvals" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/sales-notes"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/sales-notes" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/facturas"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/facturas" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/facturas/visualizar"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/facturas/visualizar" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/facturas/bsale"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/facturas/bsale" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/facturas/cuentas-por-cobrar"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/facturas/cuentas-por-cobrar" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/deudas"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/deudas" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/debt-reminders"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/debt-reminders" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/despachos"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/despachos" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/guias-despacho"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/guias-despacho" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/payments-overview"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/payments-overview" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/payments-summary"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/payments-summary" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/late-payments"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/late-payments" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/unidentified-payments"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/unidentified-payments" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/manual-payments"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/manual-payments" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/cheques"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/cheques" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/admin-settings"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/admin-settings" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/payment-requests"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/payment-requests" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/facturas/analisis-periodos"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/facturas/analisis-periodos" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/payment-dashboard"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/payment-dashboard" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/products"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/products" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/client-risk-management"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/client-risk-management" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/commercial-team"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/commercial-team" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/config-payments"
        element={
          isAuthenticated ? (
            <ConfigPayments />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/vendedores"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/vendedores" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/sales-conditions"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/sales-conditions" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/monthly-snapshots"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/monthly-snapshots" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/test-credit-notes"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/test-credit-notes" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/seller/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/seller/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/cotizaciones"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/cotizaciones" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/cotizaciones/:cotizacionId"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/cotizaciones/:cotizacionId" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Quotations Routes */}
      <Route
        path="/quotations"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/quotations" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/quotations/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/quotations/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/daily-debt-snapshots"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/daily-debt-snapshots" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/daily-debt-snapshots/client/:clientId"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/daily-debt-snapshots/client/:clientId" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Contabilidad Routes */}
      <Route
        path="/contabilidad/empresas"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/empresas" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/empresas/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/empresas/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/diarios"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/diarios" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/diarios/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/diarios/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/cuentas"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/cuentas" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/cuentas/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/cuentas/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/movimientos"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/movimientos" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/movimientos/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/movimientos/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/presupuestos"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/presupuestos" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/presupuestos/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/presupuestos/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Contabilidad Reportes Routes */}
      <Route
        path="/contabilidad/reportes"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/libro-diario"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/libro-diario" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/libro-mayor"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/libro-mayor" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/validacion-cxc"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/validacion-cxc" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/reconciliacion-cxp"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/reconciliacion-cxp" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/balance-8-columnas"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/balance-8-columnas" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/estado-situacion"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/estado-situacion" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/estado-resultados"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/estado-resultados" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/presupuesto-vs-real"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/presupuesto-vs-real" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/auditoria"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/auditoria" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/cuentas-por-pagar"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/cuentas-por-pagar" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/reportes/libro-compras"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/reportes/libro-compras" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Contabilidad Configuracion Routes */}
      <Route
        path="/contabilidad/configuracion"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/configuracion" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/configuracion/mapeo"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/configuracion/mapeo" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/configuracion/mapeo/:templateId"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/configuracion/mapeo/:templateId" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/configuracion/grupos-cuenta"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/configuracion/grupos-cuenta" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/configuracion/categorias"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/configuracion/categorias" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/configuracion/import-mappings"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/configuracion/import-mappings" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Exchange Rates Route */}
      <Route
        path="/exchange-rates"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/exchange-rates" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Purchasing Routes */}
      <Route
        path="/purchasing/orders"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/purchasing/orders" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/purchasing/orders/new"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/purchasing/orders/new" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/purchasing/orders/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/purchasing/orders/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/purchasing/ingreso"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/purchasing/ingreso" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/purchasing/modificaciones-recepcion"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/purchasing/modificaciones-recepcion" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* AP suppliers moved to Contabilidad (superadmin/admin only) */}
      <Route
        path="/contabilidad/proveedores"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/proveedores" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/proveedores/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/proveedores/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/facturas-proveedor"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/facturas-proveedor" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/contabilidad/pagos-proveedor"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/contabilidad/pagos-proveedor" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Compras: proveedores → their purchase orders */}
      <Route
        path="/purchasing/compras/proveedores"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/purchasing/compras/proveedores" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/purchasing/compras/proveedores/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/purchasing/compras/proveedores/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Legacy AP paths → redirect to their new Contabilidad location */}
      <Route
        path="/purchasing/suppliers"
        element={<Navigate to="/contabilidad/proveedores" replace />}
      />
      <Route
        path="/purchasing/suppliers/:id"
        element={<LegacySupplierDetailRedirect />}
      />
      <Route
        path="/purchasing/facturas-proveedor"
        element={<Navigate to="/contabilidad/facturas-proveedor" replace />}
      />
      <Route
        path="/purchasing/stock"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/purchasing/stock" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/purchasing/traslados"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/purchasing/traslados" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/purchasing/ajustes-ingredientes"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/purchasing/ajustes-ingredientes" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Production Routes */}
      <Route
        path="/production/recipes/aprobaciones"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/production/recipes/aprobaciones" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/production/recipes"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/production/recipes" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/production/assembly-lines"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/production/assembly-lines" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/production/batches"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/production/batches" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/production/batches/new"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/production/batches/new" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/production/batches/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/production/batches/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Costing (Costeo) Routes */}
      <Route
        path="/costeo"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/costeo" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/costeo/inventario-inicial"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/costeo/inventario-inicial" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/costeo/compras"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/costeo/compras" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/production/consumos"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/production/consumos" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/production/consumo-por-sku"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/production/consumo-por-sku" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/production/mermas"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/production/mermas" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Legacy redirect: Consumos moved from Costeo to Producción */}
      <Route
        path="/costeo/consumos"
        element={<Navigate to="/production/consumos" replace />}
      />
      <Route
        path="/costeo/movimiento-mp"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/costeo/movimiento-mp" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/costeo/movimiento-pt"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/costeo/movimiento-pt" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/costeo/conciliacion"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/costeo/conciliacion" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/costeo/variacion-inventario"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/costeo/variacion-inventario" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* WMS Routes */}
      <Route
        path="/wms"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/locations"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/locations" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/locations/:warehouseId"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/locations/:warehouseId" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/ubicaciones"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/ubicaciones" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/stock-consultation"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/stock-consultation" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/consolidated-stock"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/consolidated-stock" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* New parallel inventory module (beta) */}
      <Route
        path="/inventario/stock"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/inventario/stock" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/inventario/operaciones"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/inventario/operaciones" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/inventario/aprobaciones"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/inventario/aprobaciones" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/inventario/kardex"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/inventario/kardex" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/inventario/productos"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/inventario/productos" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/inventario/productos/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/inventario/productos/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/inventory"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/inventory" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/adjustments"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/adjustments" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* WMS Returns Routes */}
      <Route
        path="/wms/returns"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/returns" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/returns/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/returns/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/returns/:id/receive"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/returns/:id/receive" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/returns/:id/inspect"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/returns/:id/inspect" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/returns/:id/putaway"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/returns/:id/putaway" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* WMS Worker Routes */}
      <Route
        path="/wms/relocation"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/relocation" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/picking-orders"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/picking-orders" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/picking/:taskId"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/picking/:taskId" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* WMS Pallet Routes */}
      <Route
        path="/wms/pallets"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/pallets" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/pallets/:palletId"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/pallets/:palletId" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/pallet-relocation"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/pallet-relocation" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/placement"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/placement" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/placement/:requestId"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/placement/:requestId" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/wms/movements"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/wms/movements" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/metas-de-venta"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/metas-de-venta" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Ventas Routes */}
      <Route
        path="/ventas/clientes-dashboard"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/ventas/clientes-dashboard" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Maquila Routes */}
      <Route
        path="/maquila"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/maquila" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/maquila/inventory"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/maquila/inventory" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/maquila/movements"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/maquila/movements" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/maquila/movements/new"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/maquila/movements/new" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/maquila/items"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/maquila/items" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/maquila/clients"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/maquila/clients" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/maquila/recipes"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/maquila/recipes" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/maquila/consumptions"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/maquila/consumptions" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/maquila/consumptions/new"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/maquila/consumptions/new" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Totems Routes */}
      <Route
        path="/totems"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/totems" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/totems/:id"
        element={
          isAuthenticated ? (
            <RoleBasedRouter path="/totems/:id" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
